import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import NDUSchedulesPageUI from './NDUSchedulesPageUI.js'

class NDUSchedulesPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      schedules: null
    }
  }

  render() {
    return (
      <NDUSchedulesPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        schedules={this.state.schedules}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getSchedules(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getSchedules(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/documents/ndu_2/schedules`,
      cacheKey: CacheKeys.Templates(this.props.match.params.loanId, 'nduSchedules'),
      callback: this.getSchedulesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getSchedulesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      schedules: response.schedules
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.Templates(this.props.match.params.loanId, 'nduSchedules'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        schedules: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getSchedules(context)
    }
  }
}

export default withRouter(NDUSchedulesPageSF)

